<template>
    <v-container fluid class="pa-0">
        <v-overlay :value="isLoading" style="z-index: 1002">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <v-row class="ma-2">
            <v-col cols="12" sm="9" md="6" lg="4" xl="3" v-for="dev in dbDevices" :key="dev.id">
                <v-card>
                    <v-card-title class="pt-2 pb-0 indigo">
                        <h4 class="white--text">{{ dev.name }}</h4>
                    </v-card-title>
                    <v-card-title class="py-0 indigo">
                        <v-spacer></v-spacer>
                        <h6 class="white--text">{{ $moment(dev.last_received_at).format("YYYY-MM-DD HH:mm") }}</h6>
                    </v-card-title>
                    <img :src="dev.jpgBlob" width="100%" @click="openDialog(dev.id)" />
                    <v-card-text class="pa-0">
                        <v-data-table hide-default-footer :headers="tblHeader" :items="dev.sparkline" mobile-breakpoint="0" class="elevation-5" multi-sort dense>
                            <template v-slot:[`item.date`]="{ item }">
                                <v-btn class="pa-0" color="primary" small text :to="{ name: 'Playback', params: { device_id: dev.id, target_date: item.date } }">{{ item.date }}</v-btn>
                            </template>
                            <template v-slot:[`item.shot`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="item['shot']" color="pink lighten-3">
                                    <h4>{{ item["shot"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <!--
                            <template v-slot:[`item.boar`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['boar'] / 10) * 100" color="brown lighten-3">
                                    <h4>{{ item["boar"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.deer`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['deer'] / 10) * 100" color="amber lighten-2">
                                    <h4>{{ item["deer"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.other`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['other'] / 10) * 100" color="green lighten-4">
                                    <h4>{{ item["other"] }}</h4>
                                </v-progress-linear>
                            </template>
                            -->
                        </v-data-table>
                        <div class="ma-5">
                            <h4>モデル : {{ dev.model }}</h4>
                            <h4>IMEI : {{ dev.imei }}</h4>
                            <h4>SIM : {{ dev.sim }}</h4>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================= -->
        <v-dialog v-model="dialog" scrollable fullscreen>
            <v-card>
                <v-card-title class="indigo">
                    <h3 class="yellow--text">{{ dialogInfo.name }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="grey lighten-2 pa-0">
                    <comp-shot-log :device_id="dialogInfo.id"></comp-shot-log>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- ============================================= -->
    </v-container>
</template>

<script>
import JWT from "jsonwebtoken";
import CompShotLog from "@/components/CompShotLog.vue";
export default {
    name: "Dashboard",
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbDevices: [],
            dbShotLogs: [],
            tblHeader: [
                { divider: true, class: "blue darken-1 white--text", align: "center", width: "10%", text: "日付", value: "date" },
                { divider: true, class: "blue darken-1 white--text", align: "center", width: "90%", text: "画像枚数", value: "shot" },
                //{ divider: true, class: "blue darken-1 white--text", align: "center", width: "5%", text: "イノシシ", value: "boar" },
                //{ divider: true, class: "blue darken-1 white--text", align: "center", width: "5%", text: "シカ", value: "deer" },
                //{ divider: true, class: "blue darken-1 white--text", align: "center", width: "5%", text: "その他", value: "other" },
            ],
            dialog: false,
            dialogInfo: { id: 0, name: "aaaaaaaaaaaa" },
            isLoading: false,
        };
    },
    //#######################################################
    components: {
        CompShotLog,
    },
    //#######################################################
    created: async function () {
        this.jwt = this.$localStorage.get("user-jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return true;
        }
        this.myInfo = JWT.decode(this.jwt);
        if (this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return true;
        }
        //---------------------------------
        this.isLoading = true;
        //---------------------------------
        const promiseDevices = this.axiosGetDevices();
        const promiseShotLogs = this.axiosGetShotLogs();
        await promiseDevices;
        await promiseShotLogs;
        this.createSparkLineData();
        await new Promise((r) => setTimeout(r, 1000));
        this.isLoading = false;
        window.scrollTo(0, 0);
    },
    //#######################################################
    mounted: function () {},
    //#######################################################
    methods: {
        //====================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 10000,
            }).then((response) => {
                this.dbDevices = response.data.json;
                for (let idx in this.dbDevices) {
                    const device_id = this.dbDevices[idx].id;
                    this.getLastImageBlob(device_id, this.dbDevices[idx]);
                }
            });
        },
        //====================================================
        async axiosGetShotLogs() {
            //----------------------------------
            let sdate = this.$moment().add(-6, "days").format("YYYY-MM-DD");
            let edate = this.$moment().add(1, "days").format("YYYY-MM-DD");
            //----------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/shot_logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: {
                    _fields: "device_id,received_at",
                    "received_at[EQGREAT]": sdate,
                    "received_at[SMALL]": edate,
                },
                timeout: 10000,
            }).then((response) => {
                this.dbShotLogs = response.data.json;
            });
            //-------------------------------
        },
        //====================================================
        createSparkLineData() {
            //-------------------------------------------
            let shotCount = {};
            for (let obj of this.dbShotLogs) {
                const device_id = obj.device_id;
                if (!shotCount[device_id]) {
                    shotCount[device_id] = {};
                    for (let i = 0; i < 7; i++) {
                        const received = this.$moment()
                            .add(i * -1, "days")
                            .format("YYYY-MM-DD");
                        shotCount[device_id][received] = 0;
                    }
                }
                const received = this.$moment(obj.received_at).format("YYYY-MM-DD");
                if (!shotCount[device_id][received]) {
                    shotCount[device_id][received] = 0;
                }
                shotCount[device_id][received] += 1;
            }
            //-------------------------------------------
            for (let idx in this.dbDevices) {
                let device_id = this.dbDevices[idx]["id"];
                this.dbDevices[idx]["sparkline"] = [];
                for (let i = 0; i < 7; i++) {
                    const received = this.$moment()
                        .add(i * -1, "days")
                        .format("YYYY-MM-DD");
                    const ct = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received] : 0;
                    this.dbDevices[idx]["sparkline"].push({
                        date: received,
                        shot: ct,
                        boar: 0,
                        deer: 0,
                        other: 0,
                    });
                }
            }
        },
        //====================================================
        async getLastImageBlob(device_id, imgObj) {
            await this.axios({
                responseType: "blob",
                method: "GET",
                url: "/web/api/last-image/",
                params: {
                    device_id: device_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                imgObj.jpgBlob = window.URL.createObjectURL(response.data);
            });
        },
        //====================================================
        async openDialog(device_id) {
            //-------------------------
            for (let device of this.dbDevices) {
                if (device.id == device_id) {
                    this.dialogInfo = JSON.parse(JSON.stringify(device));
                    break;
                }
            }
            //this.dialogImages = [];
            //-------------------------
            this.dialog = true;
            // this.infiniteOffset = 0;
            // if (this.$refs.infiniteLoading) {
            //     this.$refs.infiniteLoading.stateChanger.reset();
            // }
            //-------------------------
        },
        //====================================================
    },
    //#######################################################
};
</script>
